module.exports = __webpack_public_path__ + "img/sm-橫式-為什麼一定要吃甜點.a3477b03.svg";